var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-card", { staticClass: "telephony-panel", attrs: { flat: "" } }, [
    _c(
      "div",
      { staticClass: "tab-bar" },
      _vm._l(_vm.tabs, function (tab) {
        return _c(
          "button",
          {
            key: tab.id,
            staticClass: "tab-btn",
            class: { active: _vm.activeTab === tab.id },
            style:
              _vm.activeTab === tab.id
                ? { "--active-color": tab.color, "--active-bg": tab.bg }
                : {},
            on: {
              click: function ($event) {
                _vm.activeTab = tab.id
              },
            },
          },
          [
            _c(
              "v-icon",
              {
                staticClass: "tab-icon",
                attrs: {
                  small: "",
                  color: _vm.activeTab === tab.id ? tab.color : "grey",
                },
              },
              [_vm._v(_vm._s(tab.icon))]
            ),
            _c(
              "span",
              {
                staticClass: "tab-label",
                class: { "hidden-xs-only": _vm.activeTab !== tab.id },
              },
              [_vm._v(_vm._s(tab.label))]
            ),
            _vm.tabLoading[tab.id]
              ? _c("v-progress-circular", {
                  staticClass: "tab-spinner",
                  attrs: {
                    size: 14,
                    width: 2,
                    indeterminate: "",
                    color: _vm.activeTab === tab.id ? tab.color : "#9e9e9e",
                  },
                })
              : _vm._e(),
            _vm.activeTab === tab.id
              ? _c("span", {
                  staticClass: "tab-indicator",
                  style: { background: tab.color },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      0
    ),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "sip",
              expression: "activeTab === 'sip'",
            },
          ],
          staticClass: "tab-pane",
        },
        [
          _c("sip-panel", {
            ref: "sipPanel",
            on: { "update:loading": (val) => (_vm.tabLoading.sip = val) },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "devices",
              expression: "activeTab === 'devices'",
            },
          ],
          staticClass: "tab-pane tab-pane-flex",
        },
        [
          _c("yealink-panel", {
            ref: "yealinkPanel",
            attrs: { embedded: "" },
            on: {
              "update:loading": (val) => (_vm.tabLoading.devices = val),
              "configure-device": _vm.configureDevice,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === "config",
              expression: "activeTab === 'config'",
            },
          ],
          staticClass: "tab-pane",
        },
        [
          _c("yealink-config-panel", {
            ref: "yealinkConfigPanel",
            attrs: { embedded: "" },
            on: {
              "update:loading": (val) => (_vm.tabLoading.config = val),
              "open-sip-panel": function ($event) {
                _vm.activeTab = "sip"
              },
              "open-yealink-panel": function ($event) {
                _vm.activeTab = "devices"
              },
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }